import KinvaDocCrud from './KinvaDocCrud'
export {KinvaDocCrud}
export default KinvaDocCrud
